'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><rect width={22} height={22} x={1} y={1} stroke="currentColor" strokeWidth={2} rx={3} /><path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="M5 10h14M5 14h14M5 18h14" /><circle cx={13} cy={5} r={0.5} stroke="currentColor" /><circle cx={16} cy={5} r={0.5} stroke="currentColor" /><circle cx={19} cy={5} r={0.5} stroke="currentColor" /></svg>;
const IconWeb = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconWeb;